const eachYear = (YEARS) => (Array.apply(null, { length: YEARS }).map(Number.call, Number)).map(x => (x + 1));
const nonNegative = x => (x > 0 ? x : 0);
const round2 = x => (parseFloat(x).toFixed(2));
const round = x => (parseInt(x, 10));

const getYears = ({ housePrice, futureHousePricePct, percentLoan, years}) => {
  const futureHousePrice = [ housePrice ];
  const amountProtected = [ housePrice ];
  eachYear(years).forEach(y => {
     const prevHousePrice = futureHousePrice[futureHousePrice.length - 1];
     const housePrice = nonNegative(prevHousePrice * (1 + futureHousePricePct * 0.01));
     futureHousePrice.push(housePrice);
     amountProtected.push(housePrice * (1 - percentLoan));
  });
  return {
    futureHousePrice: round(futureHousePrice[futureHousePrice.length - 1]),
    amountProtected: round(amountProtected[amountProtected.length - 1]),
  };
};

const LtvLevel = {
  240: {
    55: 4.00,
    56: 5.00,
    57: 6.00,
    58: 7.50,
    59: 8.50,
    60: 10.00,
    61: 11.00,
    62: 12.00,
    63: 13.00,
    64: 14.00,
    65: 15.50,
    66: 17.00,
    67: 18.00,
    68: 19.00,
    69: 20.50,
    70: 22.00,
    71: 23.00,
    72: 24.00,
    73: 24.50,
    74: 25.00,
    75: 26.00,
    76: 26.50,
    77: 27.00,
    78: 28.00,
    79: 29.00,
    80: 30.00,
    81: 31.00,
    82: 32.00,
    83: 33.00,
    84: 34.00,
  },
  260: {
    55: 5.00,
    56: 6.00,
    57: 7.00,
    58: 8.50,
    59: 9.50,
    60: 11.00,
    61: 12.00,
    62: 13.00,
    63: 14.00,
    64: 15.00,
    65: 16.50,
    66: 18.00,
    67: 19.00,
    68: 20.00,
    69: 21.50,
    70: 23.00,
    71: 24.00,
    72: 25.00,
    73: 25.50,
    74: 26.00,
    75: 27.00,
    76: 27.50,
    77: 28.00,
    78: 29.00,
    79: 30.00,
    80: 31.00,
    81: 32.00,
    82: 33.00,
    83: 34.00,
    84: 35.00,
  },
  280: {
    55: 6.50,
    56: 7.50,
    57: 8.50,
    58: 10.00,
    59: 11.00,
    60: 12.50,
    61: 13.50,
    62: 14.50,
    63: 15.50,
    64: 16.50,
    65: 18.00,
    66: 19.50,
    67: 20.50,
    68: 21.50,
    69: 23.00,
    70: 24.50,
    71: 25.50,
    72: 26.50,
    73: 27.00,
    74: 27.50,
    75: 28.50,
    76: 29.00,
    77: 29.50,
    78: 30.50,
    79: 31.50,
    80: 32.50,
    81: 33.50,
    82: 34.50,
    83: 35.50,
    84: 36.50,
  },
  300: {
    55: 8.00,
    56: 9.00,
    57: 10.00,
    58: 11.50,
    59: 12.50,
    60: 14.00,
    61: 15.00,
    62: 16.00,
    63: 17.00,
    64: 18.00,
    65: 19.50,
    66: 21.00,
    67: 22.00,
    68: 23.00,
    69: 24.50,
    70: 26.00,
    71: 27.00,
    72: 28.00,
    73: 28.50,
    74: 29.00,
    75: 30.00,
    76: 30.50,
    77: 31.00,
    78: 32.00,
    79: 33.00,
    80: 34.00,
    81: 35.00,
    82: 36.00,
    83: 37.00,
    84: 38.00,
  },
  350: {
    55: 10.00,
    56: 11.00,
    57: 12.50,
    58: 13.50,
    59: 14.50,
    60: 15.50,
    61: 16.50,
    62: 17.50,
    63: 19.00,
    64: 20.00,
    65: 21.50,
    66: 23.00,
    67: 24.00,
    68: 25.00,
    69: 26.50,
    70: 28.00,
    71: 29.00,
    72: 30.00,
    73: 30.50,
    74: 31.00,
    75: 32.00,
    76: 32.50,
    77: 33.00,
    78: 34.00,
    79: 35.00,
    80: 36.00,
    81: 37.00,
    82: 38.00,
    83: 39.00,
    84: 40.00,
  },
  400: {
    55: 12.00,
    56: 13.00,
    57: 14.50,
    58: 15.50,
    59: 16.50,
    60: 17.50,
    61: 18.50,
    62: 19.50,
    63: 21.00,
    64: 22.00,
    65: 23.50,
    66: 25.00,
    67: 26.00,
    68: 27.00,
    69: 28.50,
    70: 30.00,
    71: 31.00,
    72: 32.00,
    73: 32.50,
    74: 33.00,
    75: 34.00,
    76: 34.50,
    77: 35.00,
    78: 36.00,
    79: 37.00,
    80: 38.00,
    81: 39.00,
    82: 40.00,
    83: 41.00,
    84: 42.00,
  },
  450: {
    55: 14.00,
    56: 15.00,
    57: 16.50,
    58: 17.50,
    59: 18.50,
    60: 19.50,
    61: 20.50,
    62: 21.50,
    63: 23.00,
    64: 24.00,
    65: 25.50,
    66: 27.00,
    67: 28.00,
    68: 29.00,
    69: 30.50,
    70: 32.00,
    71: 33.00,
    72: 34.00,
    73: 34.50,
    74: 35.00,
    75: 36.00,
    76: 36.50,
    77: 37.00,
    78: 38.00,
    79: 39.00,
    80: 40.00,
    81: 41.00,
    82: 42.00,
    83: 43.00,
    84: 44.00,
  },
  500: {
    55: 17.50,
    56: 18.50,
    57: 19.50,
    58: 20.50,
    59: 21.50,
    60: 22.50,
    61: 23.50,
    62: 24.50,
    63: 25.50,
    64: 26.50,
    65: 27.50,
    66: 28.50,
    67: 30.00,
    68: 31.00,
    69: 32.00,
    70: 33.50,
    71: 34.50,
    72: 35.50,
    73: 36.00,
    74: 37.00,
    75: 38.00,
    76: 39.00,
    77: 40.00,
    78: 41.00,
    79: 42.00,
    80: 43.00,
    81: 44.00,
    82: 45.00,
    83: 46.00,
    84: 47.00,
  },
  550: {
    55: 19.50,
    56: 20.50,
    57: 21.50,
    58: 22.50,
    59: 23.50,
    60: 24.50,
    61: 25.50,
    62: 26.50,
    63: 27.50,
    64: 28.50,
    65: 29.50,
    66: 30.50,
    67: 31.50,
    68: 32.50,
    69: 33.50,
    70: 34.75,
    71: 35.75,
    72: 36.75,
    73: 37.50,
    74: 38.50,
    75: 39.50,
    76: 40.50,
    77: 41.50,
    78: 42.50,
    79: 43.50,
    80: 44.50,
    81: 45.50,
    82: 46.50,
    83: 47.50,
    84: 48.50,
  },
  600: {
    55: 21.00,
    56: 22.00,
    57: 23.00,
    58: 24.00,
    59: 25.00,
    60: 26.00,
    61: 27.00,
    62: 28.00,
    63: 29.00,
    64: 30.00,
    65: 31.00,
    66: 32.00,
    67: 33.00,
    68: 34.00,
    69: 35.00,
    70: 36.00,
    71: 37.00,
    72: 38.00,
    73: 39.00,
    74: 40.00,
    75: 41.00,
    76: 42.00,
    77: 43.00,
    78: 44.00,
    79: 45.00,
    80: 46.00,
    81: 47.00,
    82: 48.00,
    83: 49.00,
    84: 50.00,
  }
};

export const guaranteedInheritanceOutput =  (input) => {
  const { years, totalEquityReleased, clientAge, housePrice, futureHousePricePct, horizonPlan } = input;
  // const level = qualifyForEnhancedLtv ? 'Mild' : 'Standard';
  const level = horizonPlan;
  const maxLoan = round(LtvLevel[level][clientAge] * 0.01 * housePrice);
  const percentLoan = round2(totalEquityReleased / maxLoan);

  const offeredNotTaken = round2(1 - parseFloat(percentLoan));
  const percentProtected = Math.min(offeredNotTaken,
    (input.productChoice === 'prime') ? 1 : 0.5);
  const amountProtectedAtStart = round(percentProtected * housePrice);
  let { amountProtected, futureHousePrice } = getYears({
      years, housePrice, futureHousePricePct,
      percentLoan: 1 - percentProtected });
  return {
     futureHousePrice,
     level,
     maxLoan,
     percentLoan,
     offeredNotTaken,
     amountProtectedAtStart,
     amountProtected,
     percentProtected
  };
};



// WEBPACK FOOTER //
// ./src/services/GuaranteedInheritanceCalc.js